<template>
  <div v-if="!item.hidden">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path, onlyOneChild.query)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
          <svg-icon :icon-class="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" />
          <template #title>
            <span class="menu-title" :title="hasTitle(onlyOneChild.meta.title)">
              <span>{{ formatMenuTitle(onlyOneChild.meta.title) }}</span>
              <span v-if="isNewMenu(onlyOneChild.meta.title)" class="menu-new-badge">NEW</span>
            </span>
          </template>
        </el-menu-item>
      </app-link>
    </template>

    <el-sub-menu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template v-if="item.meta" #title>
        <svg-icon :icon-class="item.meta && item.meta.icon" />
        <span class="menu-title" :title="hasTitle(item.meta.title)">
          <span>{{ formatMenuTitle(item.meta.title) }}</span>
          <span v-if="isNewMenu(item.meta.title)" class="menu-new-badge">NEW</span>
        </span>
      </template>

      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script setup>
import AppLink from './Link'
import { resolveMenuPath, resolveMenuPathWithQuery } from './menuUtils'

const props = defineProps({
  // route object
  item: {
    type: Object,
    required: true,
  },
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: '',
  },
})

const onlyOneChild = ref({})

function hasOneShowingChild(children = [], parent) {
  if (!children) {
    children = []
  }
  const showingChildren = children.filter((item) => {
    if (item.hidden) {
      return false
    } else {
      // Temp set(will be used if only has one showing child)
      onlyOneChild.value = item
      return true
    }
  })

  // When there is only one child router, the child router is displayed by default
  if (showingChildren.length === 1) {
    return true
  }

  // Show parent if there are no child router to display
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: '', noShowingChildren: true }
    return true
  }

  return false
}

function resolvePath(routePath, routeQuery) {
  if (routeQuery) {
    return resolveMenuPathWithQuery(props.basePath, routePath, routeQuery)
  }
  return resolveMenuPath(props.basePath, routePath)
}

function hasTitle(title) {
  const text = formatMenuTitle(title)
  if (text.length > 5) {
    return text
  } else {
    return ''
  }
}

function isNewMenu(title) {
  return /\bnew\b/i.test(String(title || ''))
}

function formatMenuTitle(title) {
  return String(title || '').replace(/\bnew\b/gi, '').replace(/[（(]\s*[）)]/g, '').trim()
}
</script>

<style scoped>
.menu-title {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
}

.menu-title > span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-new-badge {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  height: 16px;
  padding: 0 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, #f43f5e, #f59e0b, #22c55e, #3b82f6, #8b5cf6);
  background-size: 300% 100%;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 0.04em;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.28);
  transform: translateY(-1px);
  animation: menuNewFloat 1.8s ease-in-out infinite, menuNewGradient 3s linear infinite;
}

.menu-new-badge::after {
  position: absolute;
  inset: -3px;
  content: '';
  border-radius: inherit;
  background: inherit;
  filter: blur(6px);
  opacity: 0.35;
  z-index: -1;
}

@keyframes menuNewFloat {
  0%,
  100% {
    transform: translateY(-1px);
  }
  50% {
    transform: translateY(-4px);
  }
}

@keyframes menuNewGradient {
  to {
    background-position: 300% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .menu-new-badge {
    animation: none;
  }
}
</style>